import api from '../../../lib/api'
import type { WhatsAppTemplate, WhatsAppMessage } from '../../../types'

export const communicationService = {
  // ── Templates ──────────────────────────────────────────────────────────────

  async listTemplates(): Promise<WhatsAppTemplate[]> {
    const res = await api.get('/whatsapp/templates')
    return res.data
  },

  async createTemplate(data: {
    name: string
    category: string
    language?: string
    body?: string
    purpose?: string
    variable_mapping?: Record<string, string>
  }): Promise<WhatsAppTemplate> {
    const res = await api.post('/whatsapp/templates', data)
    return res.data
  },

  async updateTemplate(
    templateId: number,
    data: {
      name: string
      category: string
      language: string
      body?: string
      purpose?: string
      variable_mapping?: Record<string, string>
    },
  ): Promise<WhatsAppTemplate> {
    const res = await api.patch(`/whatsapp/templates/${templateId}`, data)
    return res.data
  },

  async toggleTemplate(templateId: number): Promise<WhatsAppTemplate> {
    const res = await api.patch(`/whatsapp/templates/${templateId}/toggle`)
    return res.data
  },

  async deleteTemplate(templateId: number): Promise<void> {
    await api.delete(`/whatsapp/templates/${templateId}`)
  },

  // ── Messaging ──────────────────────────────────────────────────────────────

  async sendWhatsApp(
    leadId: number,
    templateName: string,
    variables?: Record<string, string>,
  ): Promise<{ message_id: number; wa_message_id: string; status: string }> {
    const res = await api.post('/whatsapp/send', {
      lead_id: leadId,
      template_name: templateName,
      variables,
    })
    return res.data
  },

  async sendWhatsAppText(
    leadId: number,
    message: string,
  ): Promise<{ message_id: number; wa_message_id: string; status: string }> {
    const res = await api.post('/whatsapp/send-text', {
      lead_id: leadId,
      message,
    })
    return res.data
  },

  async getLeadMessages(leadId: number): Promise<WhatsAppMessage[]> {
    const res = await api.get(`/whatsapp/messages/${leadId}`)
    return res.data
  },

  async sendSms(leadId: number, message: string): Promise<{ sms_id: number; status: string }> {
    const res = await api.post('/communication/sms/send', { lead_id: leadId, message })
    return res.data
  },

  async sendEmail(
    leadId: number,
    toEmail: string,
    subject: string,
    body: string,
  ): Promise<{ email_id: number; status: string }> {
    const res = await api.post('/communication/email/send', {
      lead_id: leadId,
      to_email: toEmail,
      subject,
      body,
    })
    return res.data
  },
}
